import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import Snowfall from "react-snowfall";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <Snowfall /> */}
    <App />
  </React.StrictMode>
);
